import React from "react";
import nodata from "../images/Icons/nodata.png";

export default function NoData() {
  return (
    <div className="nodata">
      <img src={nodata} className="img-fluid" alt="No data" />
      <h6 className="title mb-0">No Data Found !</h6>
    </div>
  );
}
